module.exports = __webpack_public_path__ + "img/EMS.d0d97587.svg";